import { taasInfoReducer } from '@ps20-frontend/preis-lib';
import { AnyAction } from 'redux';
import { App, TaasInfo } from '@ps20-frontend/frontend-models';
import { IAppState } from '../appState';

export const vhvTaasInfoReducer = function (
  sectionState: TaasInfo = null,
  action: AnyAction,
  appState: IAppState,
): TaasInfo {
  return taasInfoReducer(sectionState, action, App.VHV_V2, appState?.angebotsId);
};
